"use strict";

require("core-js/modules/web.dom-collections.iterator.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.search.js");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var _Search = _interopRequireDefault(require("@mui/icons-material/Search"));

var _Close = _interopRequireDefault(require("@mui/icons-material/Close"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class EnhancedTableToolbar extends _react.Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "onSearchChange", e => {
      this.setState({
        search: e.target.value
      });
      this.props.onSearch(e.target.value);
    });

    _defineProperty(this, "handleClearSearch", () => {
      this.setState({
        search: ''
      });
      this.props.onSearch('');
    });

    this.state = {
      search: ''
    };
  }

  render() {
    var _this$state$search;

    return /*#__PURE__*/_react.default.createElement(_material.Toolbar, {
      sx: {
        pl: {
          sm: 2
        },
        pr: {
          xs: 1,
          sm: 1
        }
      }
    }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
      sx: {
        flex: '1 1 100%'
      },
      style: {
        width: '50%',
        display: 'flex'
      },
      variant: "h6",
      id: "tableTitle",
      component: "div"
    }, this.props.title), this.props.showSearch && /*#__PURE__*/_react.default.createElement("div", {
      style: {
        width: '50%',
        display: 'flex',
        justifyContent: 'flex-end'
      }
    }, /*#__PURE__*/_react.default.createElement(_material.TextField, {
      placeholder: "Search",
      style: {
        width: 275,
        marginRight: 10
      },
      onChange: this.onSearchChange,
      value: this.state.search,
      InputProps: {
        startAdornment: /*#__PURE__*/_react.default.createElement(_material.InputAdornment, {
          position: "start"
        }, /*#__PURE__*/_react.default.createElement(_Search.default, null)),
        endAdornment: /*#__PURE__*/_react.default.createElement(_material.InputAdornment, {
          position: "end"
        }, /*#__PURE__*/_react.default.createElement(_material.IconButton, {
          "aria-label": "toggle password visibility",
          onClick: this.handleClearSearch,
          edge: "end"
        }, ((_this$state$search = this.state.search) === null || _this$state$search === void 0 ? void 0 : _this$state$search.length) > 0 ? /*#__PURE__*/_react.default.createElement(_Close.default, null) : null))
      },
      variant: "standard"
    })));
  }

}

EnhancedTableToolbar.propTypes = {
  title: _propTypes.default.string.isRequired,
  onSearch: _propTypes.default.func.isRequired,
  showSearch: _propTypes.default.bool.isRequired
};
var _default = EnhancedTableToolbar;
exports.default = _default;